import DataTable from '../../../../../components/DataTable/DataTable';
import React, { useCallback, useContext, useEffect, useState } from 'react';
import { FormattedMessage, FormattedNumber, useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import { getAllRsTransactions, transformTemplate } from '../../../../../store/actions/dashboard/rsTransactions';
import { LOADING, SUCCESS } from '../../../../../enums/states';
import DoubleArrowIcon from '@material-ui/icons/DoubleArrow';
import { useHistory, useRouteMatch } from 'react-router';
import socketContext from '../../../../../context/SocketContext';
import CreditCardIcon from '@material-ui/icons/CreditCard';
import MoneyIcon from '@material-ui/icons/Money';
import { Tooltip } from '@material-ui/core';

const closedTransactionsTableColumns = [
  {
    id: 'name',
    label: <FormattedMessage id={'transactionLine.name'} />,
    align: 'left',
  },
  {
    id: 'initials',
    label: <FormattedMessage id={'reservationSystem.initials'} />,
    align: 'left',
  },
  {
    id: 'itemCount',
    label: <FormattedMessage id={'transaction.itemCount'} />,
    align: 'right',
  },
  {
    id: 'amount',
    label: <FormattedMessage id={'transaction.total'} />,
    align: 'right',
  },
  {
    id: 'payments',
    label: <FormattedMessage id={'transaction.payments'} />,
    align: 'center',
  },
  {
    id: 'actions',
    label: '',
    align: 'right',
  },
];

const Payments = ({ payment }) => {
  const intl = useIntl();
  const types = {
    'credit_card_offline': <Tooltip title={intl.formatMessage({ id: 'payment.card' })}><CreditCardIcon /></Tooltip>,
    'cash': <Tooltip title={intl.formatMessage({ id: 'payment.cash' })}><MoneyIcon /></Tooltip>,
  };
  return <>
    {payment && <span>{types[payment] || payment}</span>}
  </>;
};

const ReservationSystem = () => {
  const history = useHistory();
  const { path } = useRouteMatch();
  const dispatch = useDispatch();
  const rsTransactionsRedux = useSelector((state) => state?.dashboard?.templates);

  const [rsTransaction, setRsTransaction] = useState();
  const socket = useContext(socketContext);

  const refreshTemplates = useCallback(() => {
    dispatch(getAllRsTransactions());
  }, [dispatch]);

  useEffect(() => {
    socket.on('NEW_TEMPLATE', refreshTemplates);
    socket.on('TEMPLATE_USED', refreshTemplates);

    return () => {
      socket.off('NEW_TEMPLATE', refreshTemplates);
      socket.off('TEMPLATE_USED', refreshTemplates);
    };
  });

  useEffect(() => {
    if (rsTransactionsRedux?.data) {
      rsTransactionsRedux.data.forEach((line) => {
        const { state, transactionId } = line.metadata;
        if (state === SUCCESS && transactionId) {
          socket.emit('TEMPLATE_USED');
          history.push(`${path}/sale/${transactionId}`);
        }
      });

      setRsTransaction(
        rsTransactionsRedux.data.map((line) => {
          return {
            ID: line.data.ID,
            name: line.data.name,
            initials: line.data.customer_initials,
            amount: <FormattedNumber value={line.data.totalAmount} minimumFractionDigits={2} />,
            itemCount: <FormattedNumber value={line.data.linesCount} />,
            payments: <Payments payment={line?.data?.payment_type} />,
            actions: <><DoubleArrowIcon /></>,
          };
        }),
      );
    }
  }, [rsTransactionsRedux, rsTransactionsRedux?.data, history, path, socket]);

  useEffect(() => {
    dispatch(getAllRsTransactions());
  }, [dispatch]);

  return <DataTable
    loading={rsTransactionsRedux?.metadata?.state === LOADING}
    columns={closedTransactionsTableColumns}
    data={rsTransaction}
    onRowClick={(row) => {
      dispatch(transformTemplate(row.ID));
    }}
  />;
};

export default ReservationSystem;
